<template>
  <div class="privacy-container">
    <div class="section-container">
      <div class="title-box">
        <p>法律声明 Legal Declaration</p>
      </div>
      <el-row class="mt90 content-box">
        <el-col :span="8">
          <div class="legal-box">
            <div class="legal-img">
              <span>版权声明</span>
              <img
                src="../../../assets/images/legal/1.png"
                alt=""
              />
            </div>
            <div class="legal-text">
              <p>
                本网站(www.xinxiwangdichan.com)内容（包括但不限于资料、信息、版面设计、图案、流程、声音、程序）为版权人所有的文件，仅限于为公司形象信息展示和非商业目的使用，在此并未作任何授权。未经版权人许可，任何人不得擅自（包括但不限于：复制、传播、展示、镜像、上载、下载）使用，如有合作或使用需求，请务必联系新希望地产总部品牌管理部负责人贾陈进行事宜沟通。否则版权人将依法追究其法律责任。
              </p>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="legal-box">
            <div class="legal-img">
              <span>免责声明</span>
              <img
                src="../../../assets/images/legal/2.png"
                alt=""
              />
            </div>
            <div class="legal-text">
              <p>
                版权人拥有对本网站的内容进行随时更改之权利，事前将不会另行通知。版权人不保证或声明本网站展示的资料是否正确、全面或是最新数据。
              </p>
              <p>
                本网站内的所有图片（包括但不限于插图、透视图、设计图等）、模型、文字描述等，仅作为参考信息，非开发商的任何承诺或要约。
              </p>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="legal-box">
            <div class="legal-img">
              <span>开发商声明</span>
              <img
                src="../../../assets/images/legal/3.png"
                alt=""
              />
            </div>
            <div class="legal-text">
              <p>
                本网站有关开发项目信息的介绍，均以政府最后审批文件为准。商品房买卖双方之间的权利义务以当事人签订的商品房买卖合同为准。
              </p>
              <p>
                任何个人、单位或组织因本网站或依赖其内容进行交易所引致的损失，版权人和开发商均不承担任何责任。
              </p>
            </div>
          </div>
        </el-col>
      </el-row>

      <div class="footer-text">以上声明内容的解释权归本网站所有</div>
    </div>
  </div>
</template>
<script>
export default {
  name: "PrivacyPage",
  mounted() {
    this.$nextTick(() => {
      this.$wow.init();
    });
  },
};
</script>
<style lang="scss" scoped>
.privacy-container {
  .title-box {
    padding: 71px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #6d7173;
    line-height: 35px;
    font-size: 30px;
    color: #3c4347;
  }

  .mt90 {
    margin-top: 90px;
  }

  .content-box {
    border-bottom: 1px solid #6d7173;
    > div {
      margin-bottom: 60px;
      box-sizing: border-box;
      height: 230px;
      &:nth-child(1) {
        padding-right: 37px;
      }

      &:nth-child(2) {
        padding-left: 37px;
        padding-right: 37px;
        border-left: 1px dashed #6d7173;
        border-right: 1px dashed #6d7173;
      }

      &:nth-child(3) {
        padding-left: 37px;
      }
    }

    .legal-box {
      height: 71px;
      font-size: 28px;
      color: #3c4347;
      line-height: 71px;
      margin-bottom: 15px;
    }

    .legal-img {
      height: 71px;
      font-size: 28px;
      color: #3c4347;
      line-height: 71px;
      margin-bottom: 15px;
      display: flex;
      align-items: center;
      > img {
        margin-left: 20px;
        width: 70px;
      }
    }

    .legal-text {
      text-align: justify;
      font-size: 12px;
      color: #7a7a7a;
      line-height: 20px;

      > p:first-child {
        margin-bottom: 8px;
      }
    }
  }

  .mt60 {
    margin-top: 60px;
  }

  .footer-text {
    font-size: 20px;
    color: #3c4347;
    margin-top: 28px;
  }
}
</style>
